import { render } from "./WhatsappWidget.vue?vue&type=template&id=9eeb0f46"
import script from "./WhatsappWidget.vue?vue&type=script&lang=js"
export * from "./WhatsappWidget.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__